import React from 'react';
import Button from '@99designs/frontend-components/components/Button/Button';
import { Ribbon } from '@99designs/frontend-components/components/Ribbon';
import { formatMessage } from '@99designs/frontend-components/i18n';
import AvatarWithDesignerMeta from '../../../../../shared/components/AvatarWithDesignerMeta';
import { DesignerCard } from '../../../../../shared/components/Card';
import Carousel from '../../../../../shared/components/Carousel';
import DesignCard from '../../../../../shared/components/DesignCard';
import {
    avatarPath,
    inviteDesignerToWorkPath,
    profilePath,
    testimonialPath,
} from '../../../../../shared/lib/platformUrls';
import { WinningEntryType } from '../../ContestOverviewData';

interface Props {
    winningEntry: WinningEntryType;
}

export default function WinnerCard({ winningEntry }: Props) {
    const winningCard = (
        <DesignCard
            src={winningEntry.designUrl}
            alt={formatMessage(__('Winning design by {displayName}'), {
                displayName: winningEntry.designer.user.displayName,
            })}
            ribbon={<Ribbon variations={['large']}>{__('Winner')}</Ribbon>}
            key={`design-card-${winningEntry.designer.id}`}
            variations={['lazyload']}
        />
    );

    const designCards = winningEntry.designer.designs.map((design) => (
        <DesignCard
            src={design.image}
            alt={formatMessage(__(`Design by {displayName} titled "{title}"`), {
                displayName: winningEntry.designer.user.displayName,
                title: design.title,
            })}
            key={`design-card-${design.id}`}
            variations={['lazyload']}
        />
    ));

    // NOTE: creator-search does not currently return designers who have become
    // customers, for this case, the designer level will be empty string
    const designerLevel = winningEntry.designer.designerLevel;

    return (
        <DesignerCard
            variations={['inline']}
            meta={
                <AvatarWithDesignerMeta
                    designerId={winningEntry.designer.id}
                    displayName={winningEntry.designer.user.displayName}
                    level={designerLevel ? designerLevel : undefined}
                    avgRating={winningEntry.designer.review.rating}
                    totalRatings={winningEntry.designer.review.count}
                    ctaUrl={testimonialPath()}
                    isLinked={false}
                />
            }
            gallery={
                <Carousel
                    items={[winningCard, ...designCards]}
                    variations={['centered-indicators', 'without-shadow']}
                    showTriggersOnHover={true}
                />
            }
            cta={
                designerLevel && (
                    <Button
                        href={inviteDesignerToWorkPath(winningEntry.designer.id)}
                        variations={['primary', 'fluid', 'chameleon']}
                    >
                        {__('Invite to work')}
                    </Button>
                )
            }
        />
    );
}
